module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui_cell",
    class: {
      'vux-tap-active': _vm.isLink || !!_vm.link
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "weui_cell_hd"
  }, [_vm._t("icon")], 2), _vm._v(" "), _c('div', {
    staticClass: "weui_cell_bd",
    class: {
      'weui_cell_primary': _vm.primary === 'title'
    }
  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.title) + "\n      "), _vm._t("after-title")], 2), _vm._v(" "), _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))])], 1), _vm._v(" "), _c('div', {
    staticClass: "weui_cell_ft",
    class: {
      'weui_cell_primary': _vm.primary === 'content', 'with_arrow': _vm.isLink || !!_vm.link
    }
  }, [_vm._v("\n    " + _vm._s(_vm.value) + "\n    "), _vm._t("value"), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _vm._t("child")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-7f8f47f7!./~/.1.0.35@vux-loader/src/template-loader.js!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./~/.2.0.17@vux/src/components/cell/index.vue
// module id = 318
// module chunks = 2